@if (href()) {
  <a
    pButton
    [href]="isDisabled() ? null : href()"
    [target]="target()"
    [rel]="effectiveRel()"
    [attr.aria-label]="ariaLabel()"
    [attr.data-testid]="testId()"
    [attr.aria-disabled]="isDisabled()"
    [title]="title()"
    [severity]="severity()"
    [text]="isText()"
    [outlined]="isOutlined()"
    [size]="pSize()"
    [fluid]="fullWidth()"
    [ngClass]="classes()"
    (click)="onClick($event)">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
} @else if (routerLink()) {
  <a
    pButton
    [routerLink]="isDisabled() ? null : routerLink()"
    [attr.aria-label]="ariaLabel()"
    [attr.data-testid]="testId()"
    [attr.aria-disabled]="isDisabled()"
    [title]="title()"
    [severity]="severity()"
    [text]="isText()"
    [outlined]="isOutlined()"
    [size]="pSize()"
    [fluid]="fullWidth()"
    [ngClass]="classes()"
    (click)="onClick($event)">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
} @else {
  <button
    pButton
    [type]="type()"
    [disabled]="isDisabled()"
    [attr.aria-label]="ariaLabel()"
    [attr.data-testid]="testId()"
    [title]="title()"
    [severity]="severity()"
    [text]="isText()"
    [outlined]="isOutlined()"
    [size]="pSize()"
    [fluid]="fullWidth()"
    [ngClass]="classes()"
    (click)="onClick($event)">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </button>
}

<ng-template #content>
  @if (loading()) {
    <span
      class="h-4 w-4 animate-spin rounded-full border-2 border-current border-r-transparent"
      aria-hidden="true"></span>
  }
  <ng-content></ng-content>
</ng-template>
